/* eslint-disable @typescript-eslint/no-unsafe-return */
import {connect} from "react-redux"
import State from "../../models/State"

export const mapStateToProps = (state: State) => {
    const {features} = state
    return {
        enabledTooltips: features.enableTooltips,
    }
}

export default connect(mapStateToProps)
